import React, { useState, useEffect } from "react";
import { SubscriptionService } from "../../services";
import { injectModels } from "../../redux/injectModels";
import { AuthService } from "../../services";
import CustomModal from "../../components/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import * as CONSTANTS from "../../redux/Models/Application/constants";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import { handleConsoleError } from "../../utils/common-methods";
import { toast } from "react-toastify";

const Pricing = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginUser = AuthService.getLoginUser();
  const [subscriptionPlans, setSubscriptionPlan] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLogin, setLoginStatus] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    if (!loginUser) {
      setLoginStatus(false);
    } else {
      setLoginStatus(true);
    }
    getData();
  }, []);

  const getData = async () => {
    props.application.setLoading(true);

    try {
      const res = await SubscriptionService.getSubscriptionListActive();
      if (res?.isSuccess && res?.data?.length > 0) {
        setSubscriptionPlan(res?.data);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
       //toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      }
    } catch (error) {
      props.application.setLoading(false);
        const message=handleConsoleError(error)
      toast.error(error?.message || message);
    }
  };

  const isGoldPlan = (planName) => {
    const res = planName?.toLowerCase().includes("gold");
    return res;
  };
  const isSilverPlan = (planName) => {
    const res = planName?.toLowerCase().includes("silver");
    return res;
  };
  const isBronzePlan = (planName) => {
    const res = planName?.toLowerCase().includes("bronze");
    return res;
  };

  const planClass = (planName) => {
    return "subscription-plan1";
  };

  return (
    <React.Fragment>
      <CustomModal isOpen={isModalOpen} onClose={closeModal}>
        <p> This is contact us modal</p>
      </CustomModal>
      <section className="subscription-banner">
        <div className="container">
          <h3>Choose the plan that's right for your events.</h3>
        </div>
      </section>

      <section className="subscription-plan">
        <div className="container">
          <div className="row">
            {subscriptionPlans &&
              subscriptionPlans.length > 0 &&
              subscriptionPlans.map((item, index) => (
                <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                  <div className={planClass(item?.subscriptionPlanName)}>
                    <h3 style={{ gap: "10px" }}>
                      {isGoldPlan(item?.subscriptionPlanName) && (
                        <img
                          // style={{ width: "66px" }}
                          src="/assets/images/gold-nw.png"
                          alt=""
                        />
                      )}
                      {isSilverPlan(item?.subscriptionPlanName) && (
                        <img
                          // style={{ width: "66px" }}
                          src="/assets/images/silver-nw.png"
                          alt=""
                        />
                      )}
                      {isBronzePlan(item?.subscriptionPlanName) && (
                        <img
                          // style={{ width: "66px" }}
                          src="/assets/images/bronze-nw.png"
                          alt=""
                        />
                      )}
                      {item?.subscriptionPlanName}
                    </h3>
                    <h6>
                      {" "}
                      {isGoldPlan(item?.subscriptionPlanName) &&
                        "We have the controls"}
                      {isSilverPlan(item?.subscriptionPlanName) &&
                        "Take me under your wing"}
                      {isBronzePlan(item?.subscriptionPlanName) &&
                        "I'm flying solo"}
                    </h6>
                    <div className="percent-plan">
                      {/* <h4>{item.commission}%</h4> */}
                      {/* <h4>FREE*</h4> */}
                      {/* {isBronzePlan(item.subscriptionPlanName) && ( */}
                      <h4>FREE*</h4>
                      {/* )} */}
                      <h5>
                        {isBronzePlan(item?.subscriptionPlanName)
                          ? "*only " + item?.commission + "%  buyers fees "
                          : "*from as little as " +
                            item?.commission +
                            "% buyers fees "}
                      </h5>
                    </div>
                    <div className="account-hg1">
                      <p
                        dangerouslySetInnerHTML={{ __html: item?.description }}
                      />
                    </div>

                    {isBronzePlan(item?.subscriptionPlanName) ? (
                      <div className="btn-outernw">
                        <div className="button-select">
                          <a
                            href="#!"
                            onClick={() => {
                              if (!isLogin) {
                                dispatch({
                                  type: CONSTANTS.SET_CURRENT_MODAL,
                                  payload: CONSTANTS.LOGIN_MODAL,
                                });
                                return;
                              }
                              navigate(routes.ACCOUNT_ACTIVESUBSCRIPTIONP);
                            }}
                          >
                            Free
                          </a>
                        </div>
                      </div>
                    ) : (
                      item.subscriptionPlanName && (
                        <div className="btn-outernw">
                          <div className="button-select">
                            <a
                              href="#!"
                              onClick={() => {
                                if (!isLogin) {
                                  dispatch({
                                    type: CONSTANTS.SET_CURRENT_MODAL,
                                    payload: CONSTANTS.LOGIN_MODAL,
                                  });
                                  return;
                                }
                                navigate(routes.ACCOUNT_ACTIVESUBSCRIPTIONP);
                              }}
                            >
                              Contact Us
                            </a>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};
export default injectModels(["auth", "application"])(Pricing);
